import {
  agentStatusToLabel,
  getAgentStatusColor,
} from '../../../helpers/agentHelper';
import { useTranslation } from '../../../hooks/useTranslation';
import { AgentStatus as AgentStatusType } from '../../../interfaces/Agent';
import OnlineIcon from '../Icons/OnlineIcon';
import StyledAgentStatus from './StyledAgentStatus';

interface AgentStatusProps {
  status: AgentStatusType;
}

const AgentStatus: React.FC<AgentStatusProps> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <StyledAgentStatus statusColor={status}>
      <OnlineIcon width={8} height={8} fill={getAgentStatusColor(status)} />
      {agentStatusToLabel(status, t)}
    </StyledAgentStatus>
  );
};

export default AgentStatus;
